import { createContext, useContext } from "react";

// Lets components rendered as SectionWrapper's children read its
// background-refresh state without prop drilling.
const CaseDetailStatusContext = createContext({ isLoadingStale: false });

export const useCaseDetailStatus = () => useContext(CaseDetailStatusContext);

export default CaseDetailStatusContext;
